import React from "react";
import EAAccordion from "../EAAccordion";
import EATable from "../EATable";
import PropTypes from "prop-types";

/**
 * Tabelle in einem Akkordeon verpackt, welches im Header zusätzlich die Anzahl der Elemente anzeigt
 * @param id
 * @param label
 * @param columns
 * @param loading
 * @param data
 * @param initialSortColumn
 * @param tablerest weitere Parameter für die Tabelle
 * @param rest weitere Parameter für das Akkordeon
 * @returns {JSX.Element}
 * @constructor
 */
function CollapsibleTable({ id, label, columns, loading, data, initialSortColumn, tablerest, ...rest }) {
    const buildLabel = () => {
        if (Array.isArray(data)) {
            return label + " (" + data.length + ")";
        }
        return label;
    };

    return (
        <EAAccordion id={id + "-wrapper"} label={buildLabel()} variant={"light"} defaultExpanded {...rest}>
            <EATable
                id={id + "-Table"}
                columns={columns}
                loading={loading}
                data={data}
                initialSortColumn={initialSortColumn}
                {...tablerest}
            />
        </EAAccordion>
    );
}

CollapsibleTable.propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
};

export default CollapsibleTable;
